import { render, staticRenderFns } from "./sxrz.vue?vue&type=template&id=40d4fb05&scoped=true"
import script from "./sxrz.vue?vue&type=script&lang=js"
export * from "./sxrz.vue?vue&type=script&lang=js"
import style0 from "./sxrz.vue?vue&type=style&index=0&id=40d4fb05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4fb05",
  null
  
)

export default component.exports